import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TransfersOtherBanksEventType } from '../transfers-other-banks.event.type';
import { FormGroup } from '@angular/forms';
import { TransfersOtherBanksService } from '../transfers-other-banks.service';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { EventTypes } from '../../../shared/EventTypes';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { CpfCnpjPipe } from '../../../shared/cpf-cnpj.pipe';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { AccountNumberPipe } from '../../../shared/account-number.pipe';
import { Util } from '../../../utils/util';
import { TransactionResponseModel } from '../transfer-response/models/trasanction-response.model';
import { TransactionHandlerService } from '../transfer-response/services/transaction-handler.service';
import { TransactionResponseStatus } from '../transfer-response/models/transaction-response-status.enum';

@Component({
	selector: 'app-transfer-confirmation',
	templateUrl: './transfer-confirmation.component.html',
	styleUrls: ['./transfer-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferConfirmationComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	private view = '[data-component="transfer-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedTransfer = false;

	public isAttendant = false;
	public form: FormGroup;
	public active = false;
	public disabled = false;

	constructor
	(
		private transferOBService: TransfersOtherBanksService,
		private autenticationService: AutenticationService,
		private themeService: ThemeService,
		private transactionResponseHandler: TransactionHandlerService
	) {}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION, data => {

			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION);
	}

	public getMessageConfirmedTransfer(message: boolean) {
		this.sendConfirmedTransfer = message;
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedTransfer) {
			this.hide();
		}
	}

	show() {
		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});
		this.showBalanceChange.emit(false);
	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	hide() {
		this.disabled = true;
		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(pass => {
			if (pass.Sucesso) {
				let time = 1;
				const timeLoader = setInterval(() => {
					time++;
				}, 1000);

				this.confirmTransfer(time, timeLoader);
			}

		}, error => {
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.ERROR, {step: TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION});
		});


	}

	private confirmTransfer(time: number, timeLoader: NodeJS.Timer) {
			this.transferOBService.confirmTransfer(this.transferData.id, this.transferData.transferType, this.transferData.favoredRemember).subscribe(data => {
				const processedData = Util.keysToCamel(data.Retorno) as TransactionResponseModel;
				const nextView = this.transactionResponseHandler.processResult(processedData, this.transferData.transferType, this.transferData);

				this.transferData.message = data.Mensagem;
				this.transferData.success = data.Sucesso;
				this.transferData.situation = data.SituacaoTransferencia || data.Retorno.SituacaoTransferencia;
				this.transferData.confirmationCode = data.Retorno.Sequencial;

				if (nextView) {
					if (time > 3) {
						this.hideAfterSend();
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.hideAfterSend();
						});
					}
				}
				clearInterval(timeLoader);

		}, error => {
			if (error.error.Tipo === 'RequestTimeout') {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.INIT, {});
			} else if (error.error.Tipo !== 'tokenDatablinkValidado') {
				this.transferData.message = error.error.Mensagem;
				this.transferData.success = error.error.Sucesso;
				this.hideAfterSend();
			} else {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.ERROR, { step: TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION });
			}
			
			this.disabled = false
			clearInterval(timeLoader);
		});
	}

	hideAfterSend() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT, {show: true});
			TweenMax.to(this.view, .8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}


	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 30;
	}

	buildConfirmList() {

		const accNumPipe = new AccountNumberPipe();

		this.confirmList = [];
		this.confirmList.push(new ListItem('Banco:', this.transferData.bankCode + ' - ' + this.transferData.bankDesc, 'cls_mask'));
		if (this.transferData.modality !== 'PG') {
			this.confirmList.push(new ListItem('Agência:', this.transferData.destinationAgency, 'cls_mask'));
		}
		this.confirmList.push(new ListItem('Conta:', accNumPipe.transform(this.transferData.destinationAccount), 'cls_mask'));
		this.confirmList.push(new ListItem('Titularidade:', this.transferData.ownership, 'cls_mask'));

		if (this.transferData.favoredName) {
			this.confirmList.push(new ListItem('Nome do Favorecido:', this.transferData.favoredName, 'cls_mask'));
		}

		if (this.transferData.favoredCpfCnpj) {
			const CP = new CpfCnpjPipe();
			this.confirmList.push(new ListItem('CPF/CNPJ:', Util.maskCpfCnpjPix(this.transferData.favoredCpfCnpj), 'cls_mask'));
		}

		if (this.transferData.modality === 'CC') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Corrente'));
		} else if (this.transferData.modality === 'PP') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Poupança'));
		} else if (this.transferData.modality === 'PG') {
			this.confirmList.push(new ListItem('Modalidade:', 'Conta Pagamento'));
		}
		this.confirmList.push(new ListItem('Tipo:', this.transferData.transferType));
		this.confirmList.push(new ListItem('Data:', this.transferData.dateLabel));

		const FP = new FormatPricePipe();
		this.confirmList.push(new ListItem('Valor:', FP.transform(this.transferData.value, false), 'cls_mask'));

		this.transferData.resumeList = this.confirmList;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-confirmation/transfer-confirmation.component.ts